import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
@Component({
  selector: 'app-dead-leads',
  templateUrl: './dead-leads.component.html',
  styleUrls: ['./dead-leads.component.css']
})
export class DeadLeadsComponent implements OnInit {
  type: any;
  serviceType: string = '';
  userTypeName: string = '';
  selectedServiceType: string = '';

  leads: Array<any> = []
  allStaffRecords: any;
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    public lookupModel: RsbLookupModel
  ) { }

  ngOnInit(): void {
    this.serviceType = this.lookupModel.getSelectedServiceType() ? this.lookupModel.getSelectedServiceType() : 'realEstate';
    this.selectedServiceType = this.serviceType
    this.typeServices('', this.serviceType)

  }
  getStaff(): void {
    this.rsbService.getStaffData(this.type ? this.type : 'subfranchise').subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }
  addStaff(): void {
  }
  typeServices(userType: string, serType: string): void {
    this.serviceType = serType;
    if (serType === 'realEstate') {
      this.rsbService.getAssignedFranchiseLeadsForFranchise({ "status": 4 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = [];
        }
      });
    } else if (serType === 'finTech') {
      this.rsbService.getAssignedFintechLeadsForFranchise({ "status": 4 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = [];
        }
      });
    } else if (serType === 'propService') {
      this.rsbService.getAssignedPropServiceLeadsForFranchise({ "status": 4 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else {
      alert('Something went wrong');
    }
  }
  selectService(service: string) {
    this.selectedServiceType = service;
    this.serviceType = service;
    this.lookupModel.setSelectedServiceType(this.serviceType);
    this.typeServices(this.lookupModel.getLoggedUser().type, service);
  }

}


